var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 250,
    viewBox: "0 0 142 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 235,
    height: 50,
    transform: "translate(-130.901 135.055) rotate(-35)",
    fill: "#34629D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 50,
    transform: "translate(-99.354 180.108) rotate(-35)",
    fill: "#34629D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 85,
    transform: "translate(27.6145 91.2036) rotate(-35)",
    fill: "#EE0026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/Left.95f261878af5b54af0bfe27accc82b2c.svg";
export { ForwardRef as ReactComponent };